import { getQuerySession } from "@/api/query-client";
import { Actions, AppContext } from "@Context/common/general/context";
import type { RawSessionResultsData } from "@hooks/game/activity/session/use-session-results.types";
import type { ContextType } from "react";
import { invalidateChallengeQueries } from "@hooks/common/challenges/challenge-query-cache";

type CompletedSessionData = RawSessionResultsData & { total_gameplay_duration: number };
type SessionResultsWithItems = RawSessionResultsData & Required<Pick<RawSessionResultsData, "play_item_results">>;

export const completeSession = (
  dispatch: ContextType<typeof AppContext>["dispatch"],
  playSessionId: number,
  callback: (data: CompletedSessionData) => void,
  errorCallback?: (error: unknown) => void
) => {
  const querySession = getQuerySession();

  dispatch({
    type: Actions.MetricActions.UpdatePlaySession,
    disableLoaders: true,
    payload: {
      play_session_id: playSessionId,
      is_completed: true,
      update_rating: true,
    },
  })
    .then(() => {
      dispatch({
        type: Actions.SessionActions.GetSessionResults,
        disableLoaders: true,
        payload: {
          play_session_id: playSessionId,
          resolve_previous_session: true,
        },
        onSuccess: (data: SessionResultsWithItems) => {
          const transformedData: CompletedSessionData = {
            ...data,
            total_gameplay_duration: data.play_item_results.reduce((acc, result) => acc + result.gameplay_duration, 0),
            created_at: data.creation_date,
            previous_score: data.previous_session_results?.session_score?.final_score,
          };
          console.log("transformedData", transformedData);

          // Prevent invalidation if the query session has already been changed (unlikely)
          if (querySession === getQuerySession()) void invalidateChallengeQueries();
          callback(transformedData);
        },
        onError: (error: unknown) => {
          errorCallback && errorCallback(error);
        },
      });
    })
    .catch((error: unknown) => {
      errorCallback && errorCallback(error);
    });
};
